import { Donuz } from "donuz-js/Donuz";
import Loading from "@/components/Loading.vue";

// @ is an alias to /src
export default {
    name: "redeemption",
    components: {
        Loading
    },
    data() {
        return {
            obj: {},
            redeemptions: {},
            loading: true
        };
    },
    async created() {
        this.obj = await this.getAdmins();
        this.obj = this.obj.estabelecimentos[0];
        let result = await Donuz.redeemption.getRedeemptionsByCustomer(
            sessionStorage.getItem(btoa("tokenCliente"))
        );
        if (result.status == 200) {
            this.redeemptions = result.resgates;
        }
        this.loading = false

    },
    methods: {}
};